import { SprayIcon } from './SprayIcon';

/**
 * author: Austin Andrews
 * id 0CDAFE95-E28B-4A8D-9634-C6BBB99EE598
 * name spray
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spray.svg
 * tags
 * - Agriculture 
 * - Drawing / Art 
 * - Color 
 */
export const AerosolIcon = SprayIcon;
export default AerosolIcon